import { t } from "../hooks/translations"
import css from "../style.module.scss"

export const SocialAuthSuccessScreen = function SocialAuthSuccessScreen() {
  return (
    <div className={css["container-aligned"]}>
      <p className={css.paragraph} style={{ marginBottom: 12 }}>
        {t("social_auth_success")}
      </p>
      <p className={css.paragraph}>{t("loading")}</p>
    </div>
  )
}
